import {Entity} from "../../core/commons/entity";
/**
 * Created by Lauta on 19/4/2017.
 */

export class AreaOfInterest implements Entity {
    public id: number = null;
    public name: string = "";

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }

    public equals( area : AreaOfInterest ) : boolean{
        if (area){
            return area.name == this.name;
        }
        return false
    }

}

export const areas = [
    new AreaOfInterest({id:1,name:"Salud"}),
    new AreaOfInterest({id:2,name:"Medio ambiente"}),
    new AreaOfInterest({id:3,name:"Derecho laboral"}),
    new AreaOfInterest({id:4,name:"Derecho procesal"}),
    new AreaOfInterest({id:5,name:"Criminología"}),
    new AreaOfInterest({id:6,name:"Obras públicas"})
];


// WEBPACK FOOTER //
// ./src/app/profile/domain/area-of-interest.ts